module.exports = __webpack_public_path__ + "static/media/crab.bf8bac8c.jpg";